import { FC, useEffect } from "react";
import { Table } from "../Table/Table";
import { useAppDispatch } from "toolkit/hooks";
import { ChangeVersionMode, clearVersionList, UpdateDocument } from "toolkit/documents/folders/folders.slice";
import styles from "./DocumentVersions.module.sass";

interface DocumentVersionsProps {
	close: () => void;
	targetId: number;
}

export const DocumentVersions: FC<DocumentVersionsProps> = ({ targetId }) => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		return () => {
			dispatch(UpdateDocument(Number(targetId)));
			dispatch(ChangeVersionMode(false));
			dispatch(clearVersionList());
		};
		//eslint-disable-next-line
	}, []);

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>Версии документа</h4>
			<Table targetId={targetId} />
		</section>
	);
};
